<template>
  <v-container class="pa-0 justify-center d-flex" fill-height fluid>
    <v-row id="cv" class="d-flex justify-center">
      <!-- Columna 1 -->
      <v-col cols="12" md="4" style="word-break: break-all;">
        <div class="foto-wrapper d-flex flex-column" style="width: 100%;">
          <v-card
              class="foto-card d-flex align-center justify-center"
              style="background-color: #ececec"
          >
            <v-img :src="userInfo.ruta_foto" contain class="foto-card-img"/>
          </v-card>

          <div class="mt-4">
            <div class="titulo-cv">Descripción</div>

            <div
                class="mt-2 texto-cv text-justify"
                v-html="datosPersona?.descripcion"
            ></div>
          </div>

          <div class="mt-4">
            <div class="titulo-cv">Contacto</div>

            <div class="mt-2 texto-cv">
              <div class="mt-2 texto-cv">
                <p>
                  Teléfono:
                  <span style="font-weight: 700 !important">{{
                      formatPhoneNumber(datosPersona?.telefono)
                    }}</span>
                </p>
                <p>
                  Correo:
                  <span style="font-weight: 700 !important">{{
                      datosPersona?.email_personal
                    }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </v-col>

      <!-- Columna 2 -->
      <v-col cols="12" md="6" style="word-break: break-all;">
        <p class="texto-nombre">{{ datosPersona?.nombre }}</p>
        <p></p>
        <v-divider></v-divider>
        <!--        Formación-->
        <p class="mt-5 titulo-cv">Formación y conocimientos</p>
        <v-row
            v-for="(formacionPersona, i) in formacionesFiltradas"
            :key="'frm-' + i"
        >
          <v-col cols="12" class="items--style texto-elementos">
            {{ formacionPersona?.FormacionEducativa?.nombre || formacionPersona?.otro_titulo }}
            <br/>
            {{ formacionPersona?.nombre_institucion }} |
            {{
              formatPeriod(
                  formacionPersona.fecha_inicio,
                  formacionPersona.fecha_fin,
                  formacionPersona.estudia === true
              )
            }}
          </v-col>
        </v-row>
        <v-row v-if="datosPersona?.conocimiento?.length > 0">
          <v-col cols="12" class="items--style texto-elementos">
            <div
              v-for="(ConocimientoPersona, i) in datosPersona?.conocimiento"
              :key="'cnto-' + i"
            >
              {{ ConocimientoPersona?.nombre_conocimiento }}
            </div>
          </v-col>
        </v-row>

        <!--        Experiencia laboral-->
        <p class="mt-5 titulo-cv">Experiencia Laboral</p>
        <v-row v-for="(experiaPersona, i) in datosPersona?.experiencia" :key="'A' + i">
          <v-col cols="12" class="items--style texto-elementos">
            {{ experiaPersona?.puesto }} -
            {{ experiaPersona?.lugar_trabajo }}
            <br/>
            {{
              formatPeriod(
                  experiaPersona?.fecha_inicio,
                  experiaPersona?.fecha_fin,
                  experiaPersona.trabaja === true
              )
            }}
          </v-col>
        </v-row>

        <!--        Certificados y Diplomas-->
        <p class="mt-5 titulo-cv">Certificados y Diplomas</p>
        <v-row>
          <v-col cols="12" class="items--style texto-elementos">
            <ul class="pa-0 ma-0">
              <li
                v-for="(formacionPesona, i) in certificadosFiltrados"
                :key="i"
              >
                {{ formacionPesona?.otro_titulo }} |
                {{ formacionPesona?.nombre_institucion }}
                <br/>
                {{
                  formatPeriod(
                      formacionPesona.fecha_inicio,
                      formacionPesona.fecha_fin,
                      formacionPesona.estudia == true
                  )
                }}
              </li>
            </ul>
          </v-col>
        </v-row>

        <!--        Capacidades-->
        <!-- <p class="mt-5 titulo-cv">Capacidades</p>
        <v-row class="mt-3">
          <v-col cols="9" class="items--style texto-elementos">
            <ul class="pa-0 ma-0">
              <li
                  v-for="(CapacidadPersona, i) in datosPersona?.capacidade"
                  :key="'c' + i"
              >
                {{ CapacidadPersona.nombre }}
              </li>
            </ul>
          </v-col>
        </v-row> -->

        <!--        Otros aspectos-->
        <!-- <p class="mt-5 titulo-cv">Otros aspectos</p>
        <v-row class="mt-3">
          <v-col cols="9" class="items--style texto-elementos">
            <ul class="pa-0 ma-0">
              <li
                  v-for="(item, i) in datosPersona?.otros_aspectos"
                  :key="'d' + i"
              >
                {{ item?.nombre }}
              </li>
            </ul>
          </v-col>
        </v-row> -->

        <!-- Cualidades y defectos -->
        <div>
          <p class="mt-5 titulo-cv">Cualidades y defectos</p>
          <v-row>
            <v-col cols="12" class="items--style texto-elementos">
              <ul class="pa-0 ma-0" v-if="datosPersona?.cualidades_defectos && (datosPersona?.cualidades_defectos?.cualidades?.length > 0 || datosPersona?.cualidades_defectos?.defectos?.length > 0)">
                <li
                    v-for="(cualidad, i) in datosPersona?.cualidades_defectos?.cualidades"
                    :key="'cualidad-' + i"
                >
                  {{ cualidad?.nombre }}
                </li>
                <li
                    v-for="(defecto, i) in datosPersona?.cualidades_defectos?.defectos"
                    :key="'defecto-' + i"
                >
                  {{ defecto?.nombre }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- <v-row class="d-flex justify-center mt-12 mb-3">
    <v-btn rounded dark color="#22234a" x-large @click="DescargarCV()">Descargar CV <v-icon class="ml-2 " color="white">mdi-tray-arrow-down</v-icon></v-btn>
  </v-row> -->
    <app-loader v-if="loading"></app-loader>
  </v-container>
</template>

<script>
import AppLoader from "@/components/AppLoader.vue";
import {mapState} from "vuex";

// const html2pdf = require('html2pdf.js');

export default {
  components: {
    AppLoader
  },

  props: {
    menu: {
      type: Array,
      default: () => {
        return [{uri: "/", nombre: "Inicio", icono: "mdi-home"}];
      }
    }
  },
  data: () => ({
    datosPersona: null,
    loading: false
  }),
  methods: {
    formatMonthYear(date) {
      if (!date) return "";
      const m = this.moment(date);
      if (!m || !m.isValid()) return "";
      const formatted = m.locale("es").format("MMMM YYYY");
      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    },
    formatPeriod(start, end, isCurrent) {
      if (!start) return "";

      const startMoment = this.moment(start);
      const endMoment = end ? this.moment(end) : null;

      if (!startMoment.isValid()) return "";

      if (isCurrent) {
        return `${this.formatMonthYear(start)} - Actualmente`;
      }

      if (!endMoment || !endMoment.isValid()) {
        return this.formatMonthYear(start);
      }

      if (startMoment.isSame(endMoment, "month")) {
        return this.formatMonthYear(start);
      }

      return `${this.formatMonthYear(start)} - ${this.formatMonthYear(end)}`;
    },
    async cargarDatos() {
      if (this.isTokenValido(this.token)) {
        try {
          if (typeof this.userInfo.id_persona !== "undefined") {
            const response = await this.services.datosPersona.getDatosCv(
                this.userInfo.id_persona
            );


            if (response.status == 200) {
              this.datosPersona = response.data;
              //console.log("datos cv",this.datosPersona)
            }
          }
        } catch (e) {
        } finally {
        }
      } else {
        this.temporalAlert({
          show: true,
          type: "error",
          message: "El token ya expiró, debe de volver a iniciar sesión"
        });
        this.$router.replace({name: "login"});
      }
    },
    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber) return "";
      // Verifica si el número ya tiene el formato xxxx-xxxx
      if (phoneNumber.length === 9 && phoneNumber[4] === "-") {
        return phoneNumber;
      }
      // Formatea el número si no tiene el formato xxxx-xxxx
      return phoneNumber.slice(0, 4) + "-" + phoneNumber.slice(4);
    }
  },
  computed: {
    ...mapState({
      userInfo: "userInfo",
      token: "token"
    }),

    formacionesFiltradas() {
      return (this.datosPersona?.formacion || []).filter(
        (formacion) =>
          (formacion?.TipoFormacion?.id === 1 || formacion?.TipoFormacion?.id === 3) &&
          formacion?.FormacionEducativa?.nombre &&
          formacion?.fecha_inicio &&
          (formacion?.fecha_fin || formacion?.estudia === true)
      );
    },
    certificadosFiltrados() {
      return (this.datosPersona?.formacion || []).filter(
        (certificado) => certificado.TipoFormacion?.id === 2
      );
    },

    colorChange() {
      return this.$vuetify.breakpoint.smAndDown ? "#ffff" : "#f6f6f6";
    },

    titleChange() {
      return this.$vuetify.breakpoint.smAndDown
          ? this.$vuetify.breakpoint.xs
              ? "justify-left"
              : "justify-left"
          : "justify-center";
    },

    userChange() {
      return this.userInfo?.email_personal.split("@")[0];
    },

    domainChange() {
      return `@${this.userInfo?.email_personal.split("@")[1]}`;
    },

    emailChange() {
      return this.$vuetify.breakpoint.smAndDown ? false : true;
    },

    nombresChange() {
      let a_n = this.userInfo.nombres.split(" ");

      // Filtrar elementos vacíos y 'null'
      let miArrayFiltrado = a_n.filter(
          (elemento) => elemento !== "" && elemento !== "null"
      );

      // Capitalizar la primera letra de cada palabra y unir en un solo string
      let resultadoFinal = miArrayFiltrado
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

      // Eliminar espacios en blanco al inicio y al final
      resultadoFinal = resultadoFinal.trim();

      return resultadoFinal;
    },
    apellidoChange() {
      let a_a = this.userInfo.apellidos.split(" ");

      // Filtrar elementos vacíos y 'null'
      let miArrayFiltrado = a_a.filter(
          (elemento) => elemento !== "" && elemento !== "null"
      );

      // Capitalizar la primera letra de cada palabra y unir en un solo string
      let resultadoFinal = miArrayFiltrado
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");

      // Eliminar espacios en blanco al inicio y al final
      resultadoFinal = resultadoFinal.trim();

      return resultadoFinal;
    },
    //     async DescargarCV() {
    //   const options = {
    //     margin: { top: 20, right: 10, bottom: 20, left: 10 },
    //     filename: 'mi-archivo.pdf',
    //     image: { type: 'jpeg', quality: 0.98 },
    //     jsPDF: { unit: 'mm', format: 'A4', orientation: 'portrait' },
    //   };

    //   const content = this.$refs.contentToPrint;

    //   try {
    //     const canvas = await html2canvas(content);
    //     const imageData = canvas.toDataURL('image/jpeg', options.image.quality);

    //     const pdf = new jsPDF(options.jsPDF);
    //     const pdfWidth = pdf.internal.pageSize.getWidth(); // Obtener el ancho de la página A4
    //     const pdfHeight = pdf.internal.pageSize.getHeight(); // Obtener el alto de la página A4
    //     pdf.addImage(imageData, 'JPEG', options.margin.left, options.margin.top, pdfWidth - options.margin.left - options.margin.right, pdfHeight - options.margin.top - options.margin.bottom);

    //     pdf.save(options.filename);
    //   } catch (error) {
    //     console.error('Error al generar el PDF:', error);
    //   }
    // }

    dinamicClass() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "";
        case "sm":
          return "ml-10";
        case "md":
          return "ml-10";
        case "lg":
          return "ml-10";
        case "xl":
          return "ml-10";
        case "2xl":
          return "ml-10";
      }
    },
    dinamicClassTitle() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "text-h5 mb-4";
        case "sm":
          return "text-h5 mb-4";
        case "md":
          return "text-h4 font-weight-bold";
        case "lg":
          return "text-h4 font-weight-bold";
        case "xl":
          return "text-h4 font-weight-bold";
        case "2xl":
          return "text-h4 font-weight-bold";
      }
    }
  },
  created() {
    this.loading = true;
    setTimeout(async () => {
      await this.cargarDatos();
      this.loading = false;
    }, 2000);
  }
};
</script>

<style scoped>
#cv .foto-wrapper {
  width: 100%;
}

#cv .foto-card {
  width: 100%;
  height: 300px;
  padding: 10px;
  border-radius: 34px;
  overflow: hidden;
  background-color: #ececec;
}

#cv .foto-card-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

#cv .avatar-redondo {
  border-radius: 50% !important;
  overflow: hidden;
}

.titulo-cv {
  font-weight: 700;
  font-size: 24px;
  color: #1c1e4d;
}

.texto-cv {
  font-weight: 400;
  font-size: 16px;
  color: #616161;
}

.texto-nombre {
  font-size: 40px;
  font-weight: 700;
  color: #1c1e4d;
}

.texto-elementos {
  font-weight: 600;
  font-size: 16px;
  color: #616161;
}

#cv .texto-elementos ul {
  padding-left: 0;
  margin: 0;
  list-style-position: inside;
}

@media (max-width: 960px) {
  .foto-card {
    max-width: 300px;
  }
}

@media (max-width: 960px) {
  #cv .foto-wrapper {
    max-width: 100%;
  }

  #cv .foto-card {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
